var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helix",class:{back: _vm.isInBack(),
           front: !_vm.isInBack(), 
           threeturn: _vm.is310Helix(),
           fourturn: _vm.isAlphaHelix(),
           fiveturn: _vm.isPiHelix()},style:(_vm.cssProp())})
}
var staticRenderFns = []

export { render, staticRenderFns }